export default {"src":"/_next/static/media/top-arrow.b75024b5.svg","height":307,"width":85,"blurWidth":0,"blurHeight":0};